import styled from "styled-components";

export const Card = styled.div`
	width: 100%;
	max-width: 400px;
	background: #fff;
	border: 2px solid #d2d2d2;
	border-radius: 16px;
	overflow: hidden;

	font-family: "Inter", Arial, sans-serif;
`;

export const BlogImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
`;

export const StatsBar = styled.div`
	position: absolute;
	top: 14px;
	right: 14px;
	background: #0047af;
	color: #fff;
	border-radius: 18px;
	padding: 6px 18px;
	display: flex;
	align-items: center;
	gap: 14px;
	font-size: 15px;
	font-weight: 500;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	z-index: 5;
`;

export const Stat = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const TitleOverlay = styled.div`
	background: #fff;
	padding: 12px 18px;
	border-radius: 6px;
	font-size: 18px;
	font-weight: 700;
	color: #222;
	line-height: 1.3;
	max-width: 90%;
`;

export const InfoRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 18px 0 0 0;
	padding: 0 18px;
`;

export const ProfileIcon = styled.div`
	width: 32px;
	height: 32px;
	background: #f0f0f0;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20px;
`;

export const Author = styled.span`
	color: #888;
	font-size: 1rem;
	font-weight: 500;
`;

export const Dot = styled.span`
	width: 6px;
	height: 6px;
	background: #0047af;
	border-radius: 50%;
	display: inline-block;
`;

export const DateText = styled.span`
	color: #555;
	font-size: 1rem;
	font-weight: 500;
`;

export const Star = styled.span`
	color: #0047af;
	font-size: 18px;
	margin-left: auto;
`;

export const Description = styled.p`
	color: #888;
	font-size: 1.08rem;

	padding: 0 18px;
	line-height: 1.5;
`;

export const CategoryRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 22px 0 18px 0;
	gap: 8px;
`;

export const CategoryIcon = styled.span`
	color: #0047af;
	font-size: 20px;
`;

export const CategoryText = styled.span`
	color: #222;
	font-size: 1.08rem;
	font-weight: 500;
	letter-spacing: 0.2px;
`;

export const HoverOverlay = styled.div`
	position: absolute;
	inset: 0;
	background: rgba(0, 71, 175, 0.55); /* blue with opacity */
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.5rem;
	font-weight: 600;
	opacity: 0;
	transition: opacity 0.3s;
	z-index: 2;
	pointer-events: none; /* Allows click to pass through */
`;

export const ImageWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 220px;
	overflow: hidden;

	&:hover ${HoverOverlay} {
		opacity: 1;
		pointer-events: auto;
	}
`;
